import React from 'react';

interface FilterBarProps {
  searchQuery: string;
  onSearchChange: (val: string) => void;
  selectedPlatform: string;
  onSelectPlatform: (platform: string) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  searchQuery,
  onSearchChange,
  selectedPlatform,
  onSelectPlatform,
}) => {
  const platforms = [
    { id: 'all', label: 'Tất cả Nền tảng' },
    { id: 'MT4', label: 'Chỉ MT4' },
    { id: 'MT5', label: 'Chỉ MT5' },
    { id: 'cTrader', label: 'Chỉ cTrader' },
  ];

  return (
    <div className="bg-white !rounded-xl !shadow-sm border border-gray-200 p-4 mb-10 flex flex-col md:flex-row justify-between items-center gap-4">
      {/* Search Bar */}
      <div className="relative w-full md:w-96">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg
            className="h-5 w-5 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="block w-full pl-10 pr-3 py-2 border border-gray-300 !rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm transition-colors"
          placeholder="Tìm kiếm chiến lược, tên nhà giao dịch..."
        />
      </div>

      {/* Filter Tabs */}
      <div className="flex !space-x-2 w-full md:w-auto overflow-x-auto pb-1 md:pb-0">
        {platforms.map((p) => {
          const isActive = selectedPlatform === p.id;
          return (
            <button
              key={p.id}
              onClick={() => onSelectPlatform(p.id)}
              className={`px-4 py-2 text-sm font-medium !rounded-lg border whitespace-nowrap transition-colors ${
                isActive
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              {p.label}
            </button>
          );
        })}
      </div>

      {/* Extra Filter Button */}
      <button className="hidden md:flex items-center px-4 py-2 border border-gray-300 !rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 mr-2 text-gray-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
          />
        </svg>
        Lọc thêm
      </button>
    </div>
  );
};

export default FilterBar;
